import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';
import About from '../components/About';

const AboutPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>About Us - Adept Knowledge Technologies</title>
        <meta name="description" content="Learn about Adept Knowledge Technologies — our mission, vision, and commitment to delivering technology solutions for livestock health and dairy sustainability. Startup India recognised, DPIIT registered." />
        <link rel="canonical" href="https://www.ak-tech.in/about" />
        <meta property="og:title" content="About Adept Knowledge Technologies" />
        <meta property="og:description" content="Our mission is to create technology that fuels progress, efficiency, and sustainable growth in livestock health and dairy farming." />
        <meta property="og:url" content="https://www.ak-tech.in/about" />
        <meta name="twitter:title" content="About Adept Knowledge Technologies" />
        <meta name="twitter:description" content="Our mission is to create technology that fuels progress, efficiency, and sustainable growth in livestock health and dairy farming." />
      </Helmet>
      <About />
    </Layout>
  );
};

export default AboutPage;